import {http} from './index';
import {GetAskSituationParams,SearchByTime,TeamAnswerLine,TeamAnswerBar, PersonalServiceOverViewLine, PersonalServiceTimeRankBar} from '@types';

//今日答疑量统计
export const getTodayAskSituation = (params?:SearchByTime) => http.get('/teaching-workbench/qa/ask/extend/today',params);

//评价统计
export const getAppraisalSituation = (params?:SearchByTime) => http.get('/teaching-workbench/ask/appraisal/statistic',params);

//今日答疑量统计
export const getAskSituation = (params: GetAskSituationParams, options?: {}) => http.get('/teaching-workbench/ask/statistics', params, options);

//管理者工作台答疑列表维度数量统计
export const getAskConditionCount = (params: { isRefresh: boolean }, options?: {}) => http.get('/teaching-workbench/ask/condition-count-v2', params, options);

//我的答疑概览
export const getAskOverviewCount = (params:{isRefresh:boolean}) => http.get('/teaching-workbench/count/v1/my/ask/overview',params);

//我的答疑数
export const getAskNumCountLine = (params:{countType:number,isRefresh:boolean}) => http.get('/teaching-workbench/count/v1/my/ask/num',params);

//我的答疑数
export const getAskCountPie = (params:{isRefresh:boolean}) => http.get('/teaching-workbench/count/v1/my/ask/count',params);

//私教服务数量
export const getPersonalServiceCountBar = (params:{teacherId:number}) => http.get(`/teaching-workbench/booking/statistical/personal/${params.teacherId}`);

//团队答疑概览
export const getTeamAnswerLine = (params:TeamAnswerLine) => http.post('/teaching-workbench/count/v1/team-answer/overview',params);

//团队答疑排名
export const getTeamAnswerBar = (params: TeamAnswerBar) => http.post('/teaching-workbench/count/v1/team-answer/rank', params);

//私教服务概览统计
export const getPersonalServiceOverViewData = (params:PersonalServiceOverViewLine) => http.post('/teaching-workbench/booking/statistical',params);

//团队答疑排名
export const getPersonalServiceTimeRankData = (params:PersonalServiceTimeRankBar) => http.post('/teaching-workbench/booking/statistical/teacher/rank',params);

//查询用户(导师)列表
export const getTeamTeacherList = (params: { projectId?: string | number }) => http.get('/teaching-workbench/count/v1/team-answer/team-answer-rank-user', params);

//获取私教通时排名导师数据
export const getServiceTeacherList = (params: { projectId?: string | number }) => http.get(`/teaching-workbench/booking/statistical/teacher/ability/${params.projectId}`);

//导出私教服务概览
export const exportPersonalServiceData = (params:PersonalServiceOverViewLine) => http.post('/teaching-workbench/booking/statistical/export',params, { responseType: 'blob'});



